import {Banner} from '@primer/react'
import {AriaStatus} from '@primer/react/experimental'

import {LABELS} from '../constants/labels'
import styles from './LowQualityWarningBanner.module.css'

interface LowQualityWarningBannerProps {
  onDismiss: () => void
}

export function LowQualityWarningBanner({onDismiss}: LowQualityWarningBannerProps) {
  return (
    <Banner
      hideTitle
      variant="info"
      layout="compact"
      title={LABELS.lowQualityCommentWarning.title}
      description={<AriaStatus announceOnShow>{LABELS.lowQualityCommentWarning.message}</AriaStatus>}
      onDismiss={onDismiss}
      flush
      className={styles.banner}
    />
  )
}

try{ LowQualityWarningBanner.displayName ||= 'LowQualityWarningBanner' } catch {}